import moment from 'moment'
import { fetchPendingInvoices } from '../../actions'
import { fetchPaidInvoices } from '../../../PaidInvoices/actions'
import { fetchAccountBalance } from '../../../Account/actions'
import { getCurrentTimeWithCurrentTimezone } from '../../../../../../utils'

export const submitMakePaymentForm = () => {
  return(dispatch, getState) => {
    const state = getState()
    const { organization, resident } = state
    const { amount, name, payment_source, id, paid_at, description} = state.makePaymentForm
    const invoice = state.pendingInvoices.pendingInvoices.filter(inv=>inv.id === id)[0]

    function getPaymentMethod(){
      switch(payment_source.kind){
        case 'card':
        case 'bank_account':
          return 'online'
        default:
          return payment_source.kind
      }
    }

    function getPaymentSource(){
      if(payment_source.kind === 'card' || payment_source.kind === 'bank_account'){
        return payment_source.id
      } else {
        return undefined
      }
    }

    $.ajax({
      url: `/organizations/${organization.name}/invoices/${id}/make_payment.json`,
      method: 'PATCH',
      data: { 
        invoice : {
          resident_id: resident.id,
          payment_method: getPaymentMethod(),
          payment_source_id: getPaymentSource(),
        },
        charge: {
          paid_at: moment(paid_at).format('YYYY-MM-DD'),
          description,
        }
      },
      success: () => {
        dispatch(fetchAccountBalance())
        dispatch(fetchPendingInvoices())
        dispatch(fetchPaidInvoices())
        dispatch({type: 'SUCCESS_SUBMIT_MAKE_PAYMENT'})
        const nowWithTimezone = getCurrentTimeWithCurrentTimezone();
        dispatch({ type: "UPDATE_RESIDENT_UPDATED_AT", 
          payload: { resident_updated_at: nowWithTimezone }});
      },
      error: xhr => {
        dispatch(fetchPendingInvoices())
        const errors = $.parseJSON(xhr.responseText).errors
        dispatch({type: 'FAILED_SUBMIT_MAKE_PAYMENT', payload: errors })
      }
    })
  }
}

export const updateMakePaymentField = (payload) => {
  return { type: 'UPDATE_MAKE_PAYMENT_FIELD', payload }
}
